import './App.css';
import {Route,BrowserRouter as Router,Routes} from 'react-router-dom';
import React from 'react'
import Navbar from './components/Navbar';
import {Home,About,Contact,Projects,Welcome,Skills,Achievements,Experience,Socials} from './pages'
const App = () => {
  return (
    <main className='bg-slate-300/20 h-full'>
      <Router>
        <Navbar/>
        <Routes>
          <Route path="/" element={<Home/>}/>
          <Route path="/about" element={<About/>}/>
          <Route path="/skills" element={<Skills/>}/>
          <Route path="/projects" element={<Projects/>}/>
          <Route path="/achievements" element={<Achievements/>}/>
          <Route path="/experience" element={<Experience/>}/>
          <Route path="/socials" element={<Socials/>}/>
          <Route path="/contact" element={<Contact/>}/>
          <Route path="/welcome" element={<Welcome/>}/>
        </Routes>
      </Router>
    </main>
  )
}

export default App